<script lang="ts" setup>
interface Props {
  label: string;
  value?: string | number | undefined | null;
  subtitle?: string;
}

const props = defineProps<Props>();
</script>

<template>
  <div class="option" :class="{ 'has-subtitle': props.subtitle }">
    <div class="b-title">{{ props.label }}</div>
    <div v-if="props.subtitle" class="b-subtitle">{{ props.subtitle }}</div>
  </div>
</template>

<style lang="scss" scoped>
.option {
  display: flex;
  gap: var(--space-8);

  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;

  &.has-subtitle {
    flex-direction: column;
    gap: var(--space-2);
  }
}

.b-title {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;

  font-weight: var(--font-weight-regular);
  flex-shrink: 1;
  color: var(--color-gray-900);
}

.b-subtitle {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;

  font-weight: var(--font-weight-regular);
  font-size: var(--font-size-12);
  flex-shrink: 1;
  color: var(--color-gray-500);
}
</style>
